<template>
    <div class="pet-info-container">
        <!-- 宠物头像 -->
        <div class="avatar-section">
            <van-image
                round
                width="120px"
                height="120px"
                fit="cover"
                :src="imageUrl"
                class="pet-avatar"
            >
                <template v-slot:error>
                    <div class="avatar-placeholder">
                        <van-icon name="photo-fail" size="48" color="#fff" />
                    </div>
                </template>
            </van-image>
        </div>

        <!-- 宠物信息卡片 -->
        <div class="info-card">
            <h1 class="pet-name">{{info.Petname}}</h1>
            
            <!-- 生日和体重 -->
            <div class="pet-stats">
                <div class="stat-item">
                    <img :src="require('../assets/birth.png')" style="width: 18px; height: 18px;" />
                    <span class="stat-label">{{info.Birthday}}</span>
                </div>
                <div class="stat-item">
                    <img :src="require('../assets/weight.png')" style="width: 18px; height: 18px;" />
                    <span class="stat-label">{{info.Weight}}</span>
                </div>
            </div>

            <!-- 联系按钮 -->
            <div class="action-buttons">
                <van-button 
                    type="primary" 
                    block 
                    round
                    icon="phone-o"
                    :url="phoneUrl"
                    size="large"
                    class="action-btn call-btn"
                >
                    {{ $t("messages.call_onwer") }}
                </van-button>
                <van-button 
                    plain 
                    type="primary" 
                    block
                    round
                    icon="envelop-o"
                    :url="emailUrl"
                    size="large"
                    class="action-btn email-btn"
                >
                    {{ $t("messages.send_email") }}
                </van-button>
            </div>
        </div>

        <!-- 联系信息卡片 -->
        <div class="contact-card">
            <h2 class="contact-title">
                <van-icon name="info-o" size="20" color="#5072ff" />
                {{ $t("messages.contact_info") }}
            </h2>
            
            <div class="contact-content">
                <div class="contact-item">
                    <van-icon name="phone-circle-o" size="20" color="#5072ff" />
                    <span class="contact-text">{{info.Phone}}</span>
                </div>
                
                <van-divider />
                
                <div class="contact-item note-item">
                    <van-icon name="chat-o" size="20" color="#5072ff" />
                    <span class="note-text">{{info.Note}}</span>
                </div>
            </div>
        </div>

        <!-- 修改信息链接 -->
        <div class="modify-section">
            <p class="modify-link" @click="onclick">
                <van-icon name="edit" size="16" />
                {{ $t("messages.modify_info") }}
            </p>
        </div>

        <!-- 修改密钥对话框 -->
        <van-dialog 
            v-model:show="showModify" 
            :title="$t('messages.modify_key')" 
            show-cancel-button 
            :beforeClose="beforeClose"
            :confirmButtonText="$t('messages.ok')"
            :cancelButtonText="$t('messages.cancel')"
            confirm-button-color="#5072ff"
        >
            <van-field 
                v-model="modify_key" 
                label="Key" 
                type="password"
                :placeholder="$t('messages.modify_key_ruler')"
                :rules="[{ required: true, message: $t('messages.modify_key_ruler') }]"
                left-icon="lock"
            />
        </van-dialog>
    </div>
</template>
  
  <script>
  import 'vant/lib/index.css';
  import { Image as VanImage ,Row,Col,CellGroup,Button,Icon,Divider,Dialog,showToast,Field} from 'vant';
  import {ref as refs,getDownloadURL} from "firebase/storage";
  import {storage,db} from "../main.js";
  import { doc, getDoc } from "firebase/firestore"; 
  import { ref } from 'vue';
  import {md5 } from 'js-md5';
  import { useI18n } from 'vue-i18n';


  


  export default {
    name: 'PetInfo',
    props: {
      info: Object,
      uid:String
    },
    components:{
        [VanImage.name]:VanImage,
        [Row.name]:Row,
        [Col.name]:Col,
        [Icon.name]:Icon,
        [CellGroup.name]:CellGroup,
        [Button.name]:Button,
        [Divider.name]:Divider,
        [Dialog.name]:Dialog,
        [Field.name]:Field,
        [showToast.name]:showToast,
        
        
    },
    setup(props, context){
        const { t } = useI18n();
        
        const modify_key = ref('');
        const beforeClose = (action)=>
            new Promise( (resolve) => {
            console.log("Action",action)
            if (action == 'confirm') {
                console.log("Action1",action)
             const Uid = props.uid;
             const docSnap =   getDoc(doc(db, "key", Uid));
             docSnap.then ( snap => {
                //console.log("docSnap",snap)
                if (snap.exists() && (md5(modify_key.value) == snap.data().Modify_key)) {
                    console.log('suc', );
                    showToast({
                        message: t('messages.verify_success'),
                        type: 'success',
                        duration: 1500
                    });
                    context.emit('edit');
                }else{
                    /*const that = getCurrentInstance(); // 获取当前组件实例
                    console.log("that",this)
                    showToast(that.$t('messages.key_error'));*/
                    
                    showToast({
                        message: t('messages.key_error'),
                        type: 'fail',
                        duration: 2000
                    });
                    context.emit('showerrorMsg');
                }
                //console.log("docSnap",snap)
                resolve(true);
             });
            } else {
                // 拦截取消操作
                resolve(true);
            }
        });
    
        return {
            beforeClose,
            modify_key,
        }
    },
    created(){
         this.setupInfo()
    },
    methods:{
        setupInfo(){
        this.phoneUrl="tel:"+this.info.Phone
        this.emailUrl="mailto:"+this.info.Email
        if(this.info.Image != ""){
            getDownloadURL(refs(storage,this.info.Image)).then((downloadURL) => {
              console.log('File available at', downloadURL);
              this.imageUrl = downloadURL
            });
        }
        this.key_error = this.$t('messages.key_error')
        
       },
       
       onclick(){
        this.modify_key = ""
        this.showModify = true
       }
    },
    data(){
        return{
            imageUrl:"",
            phoneUrl:"",
            emailUrl:"",
            showModify:false,
            key_error:"",
        }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .pet-info-container {
    width: 100%;
    max-width: 600px;
    padding: 20px 0;
  }

  /* 头像区域 */
  .avatar-section {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
  }

  .pet-avatar {
    border: 4px solid rgba(255, 255, 255, 0.9);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  }

  .avatar-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  }

  /* 信息卡片 */
  .info-card {
    background: #ffffff;
    border-radius: 16px;
    padding: 24px 20px;
    margin-bottom: 16px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  }

  .pet-name {
    color: #323233;
    font-size: 28px;
    font-weight: 700;
    margin: 0 0 16px 0;
    text-align: center;
  }

  /* 宠物统计信息 */
  .pet-stats {
    display: flex;
    justify-content: center;
    gap: 32px;
    margin-bottom: 24px;
  }

  .stat-item {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .stat-label {
    color: #646566;
    font-size: 15px;
  }

  /* 操作按钮 */
  .action-buttons {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .action-btn {
    height: 48px;
    font-size: 16px;
    font-weight: 600;
  }

  .call-btn {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  }

  .email-btn {
    border-color: #5072ff;
    color: #5072ff;
  }

  /* 联系信息卡片 */
  .contact-card {
    background: #ffffff;
    border-radius: 16px;
    padding: 20px;
    margin-bottom: 16px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  }

  .contact-title {
    color: #323233;
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 16px 0;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .contact-content {
    display: flex;
    flex-direction: column;
  }

  .contact-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 8px 0;
  }

  .contact-text {
    color: #323233;
    font-size: 16px;
    flex: 1;
    word-break: break-all;
  }

  .note-item {
    align-items: flex-start;
  }

  .note-text {
    color: #646566;
    font-size: 15px;
    line-height: 1.6;
    flex: 1;
    word-break: break-all;
  }

  /* 修改链接 */
  .modify-section {
    text-align: center;
    padding: 16px 0;
  }

  .modify-link {
    color: rgba(255, 255, 255, 0.9);
    font-size: 15px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: all 0.3s ease;
    padding: 8px 16px;
    border-radius: 20px;
  }

  .modify-link:hover {
    color: #ffffff;
    background: rgba(255, 255, 255, 0.1);
  }

  .modify-link:active {
    transform: scale(0.95);
  }

  /* Vant 组件定制 */
  :deep(.van-divider) {
    margin: 12px 0;
    border-color: #ebedf0;
  }

  :deep(.van-field__label) {
    color: #323233;
    font-weight: 500;
  }

  /* 响应式优化 */
  @media (max-width: 480px) {
    .pet-name {
      font-size: 24px;
    }
    
    .pet-avatar {
      width: 100px !important;
      height: 100px !important;
    }
    
    .action-btn {
      height: 44px;
      font-size: 15px;
    }
  }

  @media (min-width: 768px) {
    .pet-info-container {
      padding: 32px 0;
    }
    
    .info-card,
    .contact-card {
      padding: 28px 24px;
    }
  }
  </style>
  